import { RcClasses, spacing, } from '../../../../foundation';
export var RcListItemPrefix = 'RcListItem';
export var RcListItemRipplePrefix = RcListItemPrefix + "TouchRipple";
export var RcListItemMultilineClassName = RcListItemPrefix + "-multiline";
export var RcListItemClasses = RcClasses(['gutters', 'dense', 'selected', 'focusVisible'], RcListItemPrefix);
export var RcListItemTopAndBottomPaddings = {
    small: spacing(1),
    medium: spacing(1.25),
};
export var colorMap = {
    primary: 'interactive.f01',
    secondary: 'highlight.f02',
    black: 'action.grayLight',
};
export var RcListItemRippleClasses = RcClasses(['rippleVisible'], RcListItemRipplePrefix);
